import { render, staticRenderFns } from "./impacted-person-details.vue?vue&type=template&id=3e1b3d29&scoped=true"
import script from "./impacted-person-details.vue?vue&type=script&lang=js"
export * from "./impacted-person-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1b3d29",
  null
  
)

export default component.exports